<template>
  <NuxtLayout>
    <NuxtLoadingIndicator :height="8" :color="loadingBarColor" />
    <NuxtPage />
  </NuxtLayout>
</template>

<script lang="ts" setup>
const loadingBarColor = '#d18f00';
</script>
